import { TODAY } from '@epi-constants/downloadReports';
import { FormFields } from '@epi-forms/helpers';
import {
  BeneficiaryFormValues,
  IBeneficiary,
  IBeneficiaryData
} from '@epi-models/pages/Beneficiaries';
import { hasDatePassed, parseStringToDate } from '@epi-helpers/dateHelper';

export const benefitsDataMapper = (
  beneficiary: IBeneficiaryData,
  editingMode: boolean,
  isLunchBenefitActive?: boolean
) => {
  const {
    personId,
    firstName,
    lastName,
    emailAddress,
    benefitGroupIds,
    personalId,
    endOfBenefit,
    endOfFunds,
    createdAt,
    employmentType,
    groupId,
    costCenter,
    employeeNumber,
    floor,
    department,
    region,
    startOfBenefit,
    benefitPercentage,
    benefitLunchMaxWorkingDays,
    pendingLoadDate
  } = beneficiary;
  return {
    [FormFields.FirstName]: firstName ?? '',
    [FormFields.LastName]: lastName ?? '',
    [FormFields.PersonID]: personId?.toString() ?? '',

    [FormFields.EmailAddress]: emailAddress ?? '',
    [FormFields.PersonalID]: personalId ?? '',

    [FormFields.EndOfBenefit]: endOfBenefit ?? '',
    [FormFields.EndOfFunds]: endOfFunds ?? '',
    [FormFields.CreatedAt]: createdAt ?? '',

    [FormFields.EditMode]: editingMode,
    [FormFields.EditingType]: false,

    [FormFields.Entitled]: startOfBenefit ?? '',

    [FormFields.BenefitGroupIds]: benefitGroupIds ?? [],

    [FormFields.EmployeeType]: employmentType ?? '',
    [FormFields.EmployeeNumber]: employeeNumber ?? '',
    [FormFields.CostCenterNumber]: costCenter ?? '',
    [FormFields.Floor]: floor ?? '',
    [FormFields.Department]: department ?? '',
    [FormFields.Region]: region ?? '',

    [FormFields.EmployeePercentage]: benefitPercentage ?? '',

    [FormFields.DaysForLunari]: benefitLunchMaxWorkingDays ?? '',

    [FormFields.LunchBenefitActive]: isLunchBenefitActive ?? false,

    [FormFields.PendingLoadDate]: pendingLoadDate ?? '',
    [FormFields.GroupId]: groupId ?? 0
  } as BeneficiaryFormValues;
};

export const addBenefitsDataMapper = (isLunchBenefitActive?: boolean) =>
  ({
    [FormFields.FirstName]: '',
    [FormFields.LastName]: '',
    [FormFields.PersonalID]: '',
    [FormFields.EmailAddress]: '',
    [FormFields.EmployeeNumber]: '',
    [FormFields.CostCenterNumber]: '',
    [FormFields.Floor]: '',
    [FormFields.Department]: '',
    [FormFields.Region]: '',
    [FormFields.EndOfBenefit]: '',
    [FormFields.EndOfFunds]: '',
    [FormFields.EmployeeType]: '',
    [FormFields.EmployeePercentage]: '',
    [FormFields.EditingType]: false,
    [FormFields.LunchBenefitActive]: isLunchBenefitActive,
    [FormFields.Entitled]: '',
    [FormFields.GroupId]: 0
  } as BeneficiaryFormValues);

export const disableSaveButtonForBeneficiariesDataModal = (
  date: null | Date,
  isEntitledDate = false
) => {
  if (date === null) {
    return isEntitledDate;
  }

  if (date) {
    return date?.getTime() < TODAY.setHours(0, 0, 0, 0);
  }

  return true;
};

export const isActiveBeneficiary = (beneficiary: IBeneficiary) =>
  !beneficiary.endOfFunds ||
  !hasDatePassed(parseStringToDate(beneficiary.endOfFunds));
